<!-- [モーダル] -->
<div
  #modalContents
  class="l-modal01__contents js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="cabin-class-selector-modal-title"
>
  <!-- 閉じるボタン -->
  <div #modalHead class="l-modal01__header js-modal-head">
    <div class="p-modal-head01">
      <h1
        id="cabin-class-selector-modal-title"
        class="p-modal-head01__title"
        [innerHTML]="'label.changeCabin.title' | staticMsg"
      ></h1>
      <button
        id="cabin-class-selector-modal-close-btn"
        class="p-modal-head01__close js-modal-close"
        (click)="cancelCabinClassSelector()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody class="l-modal01__body js-modal-body">
    <!-- キャビンクラス選択ボディ部 -->
    <ul class="c-fare-check-list" [formGroup]="formGroupCabinClass">
      <!-- キャビンクラス -->
      <ng-container *ngFor="let cabinClassOption of cabinList; index as cabinIndex">
        <li class="c-fare-check-list__item">
          <div class="c-fare-check-list__item-head">
            <label for="{{ 'radio' + cabinIndex }}" class="c-fare-check-list__item-wrap">
              <span class="c-fare-check-list__item-label"
                ><em class="c-fare-check-list__item-em">{{ cabinClassOption.textContent }}</em></span
              >
            </label>
          </div>
          <div class="c-fare-check-list__item-body">
            <div class="c-form-element-radio">
              <div class="c-form-element-radio__wrap">
                <input
                  type="radio"
                  name="{{ this.FORM_GROUP_NAME }}"
                  id="{{ 'radio' + cabinIndex }}"
                  class="c-form-element-radio__input"
                  aria-invalid="false"
                  formControlName="{{ this.FORM_GROUP_NAME }}"
                  value="{{ cabinClassOption.value }}"
                />
                <label for="{{ 'radio' + cabinIndex }}" class="c-form-element-radio__label">
                  <span class="c-form-element-radio__check"></span>
                  <span class="c-form-element-radio__text u-visually-hidden">{{ cabinClassOption.textContent }}</span>
                </label>
              </div>
            </div>
          </div>
        </li>
      </ng-container>
    </ul>
    <!-- //キャビンクラス選択ボディ部 -->
  </div>

  <div class="l-modal01__footer">
    <div class="p-modal-foot01">
      <!-- 適用ボタン -->
      <button
        id="cabin-class-selector-modal-apply-btn"
        class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
        (throttleClick$)="applyCabinClassSelector()"
        aswThrottleClick
      >
        <span class="c-btn-primary__text" [innerHTML]="'label.confirm' | staticMsg"></span>
      </button>
    </div>
  </div>
</div>

<!-- //[モーダル] -->
